import "./brandLoader.css";

/**
 * Full-screen brand loader — boot, auth, and route transitions.
 * Use `variant="route"` for Suspense (lower z-index, pointer-events none).
 */
export default function BrandLoader({ variant = "overlay", label }) {
  return (
    <div
      className={`brand-loader${variant === "route" ? " is-route" : ""}`}
      role="status"
      aria-live="polite"
      aria-label={label || "Chargement"}
    >
      <div className="brand-loader-mark">
        <div className="brand-loader-spinner" aria-hidden="true" />
      </div>
    </div>
  );
}
